<template>
    <!--START HOME-->
        <section class="section bg-home home-half scroll-select" id="home">
            <div class="bg-overlay"></div>
            <div class="display-table">
                <div class="display-table-cell">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-8 offset-lg-2 text-white text-center">
                                <h1 class="home-title">Iż-Żejjed Kollu Żejjed</h1>
                                <p class="padding-t-15 home-desc">7 ta' Settembru </p>
                                <p class="padding-t-15 home-desc">Kulħadd għall-Belt</p>
                                <p class="padding-t-15 home-desc">10am- Quddiem il-Qorti</p>
                                <p class="play-shadow margin-t-30 margin-l-r-auto">
                                    <a href="https://www.youtube.com/watch?v=z7Y2tQQssTY" class="play-btn video-play-icon"><i class="mdi mdi-play text-center"></i></a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-pattern-effect">
                <img src="images/bg-pattern.png" alt="">
            </div>
        </section>
        <!--END HOME-->
</template>

<script>
"use strict";
export default {
  name: 'HeroSection',
  props: {
  }
}
</script>
